import { EEntity } from '../enums/entity.enum';

export const getPluralEntityName = (entity: EEntity): string => {
  if (!entity) {
    return 'Unknown entity';
  }

  if (entity === EEntity.OPPORTUNITY) {
    return 'opportunities';
  }

  return `${entity}s`;
};
